import React, { useState, useEffect } from 'react';
import avevaApi from '@services/avevaApiService';

interface AvevaDashboardProps {
  onSelectStream: (streamId: string) => void;
}

interface DashboardData {
  connectionStatus?: string;
  totalStreams?: number;
  recentData?: Array<{
    streamId: string;
    data: { Value?: any; Measurement?: any; Time?: string; Timestamp?: string };
  }>;
  errors?: Array<{ type?: string; message?: string; error?: string }>;
}


const AvevaDashboard = ({ onSelectStream }: AvevaDashboardProps) => {
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    setLoading(true);
    try {
      const response = await avevaApi.getDashboardData();
      setDashboardData(response.data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading dashboard...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="aveva-dashboard">
      <div className="dashboard-cards">
        <div className="card">
          <h3>Connection Status</h3>
          <div className={`status ${dashboardData?.connectionStatus}`}>
            {dashboardData?.connectionStatus?.toUpperCase() || 'UNKNOWN'}
          </div>
        </div>

        <div className="card">
          <h3>Total Streams</h3>
          <div className="metric-value">{dashboardData?.totalStreams || 0}</div>
        </div>

        <div className="card">
          <h3>Recent Data Points</h3>
          <div className="metric-value">{dashboardData?.recentData?.length || 0}</div>
        </div>

        <div className="card">
          <h3>Errors</h3>
          <div className="metric-value error-count">{dashboardData?.errors?.length || 0}</div>
        </div>
      </div>

      {dashboardData?.recentData?.length ? (
        <div className="recent-data">
          <h3>Recent Stream Data</h3>
          <table>
            <thead>
              <tr>
                <th>Stream ID</th>
                <th>Latest Value</th>
                <th>Timestamp</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {dashboardData.recentData.map((item) => (
                <tr key={item.streamId}>
                  <td>{item.streamId}</td>
                  <td>{JSON.stringify(item.data?.Value || item.data?.Measurement || 'N/A')}</td>
                  <td>
                    {new Date(item.data?.Time || item.data?.Timestamp || '').toLocaleString()}
                  </td>
                  <td>
                    <button className="view-btn" onClick={() => onSelectStream(item.streamId)}>
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}


    </div>
  );
};

export default AvevaDashboard;
